export default "__VITE_PUBLIC_ASSET__51bfc71b__"